// auth
export const NOTIFICATIONS_ENDPOINT = '/v1/notifications'

// notify
export const NOTIFY_ENDPOINT = {
  BASE: '',
  SUBSCRIPTIONS: '/v1/subscriptions',
}

// trades
export const TRADES_ENDPOINT = '/v1/trades'
export const SEND_PARTIAL_TRADE_INFO = '/v1/trades/partial-trade-info'
export const INIT_TRADE = '/v1/trades/initiate'
export const ESTIMATE_TRADE_ENDPOINT = '/v1/trades/estimate'
export const GET_TRADE_HAS_COMMITMENT_QUOTES = '/v1/trades/has-commitment-quotes'
export const GET_TRADE_COMMITMENT_QUOTES = '/v1/solver/trades'

// tokens
export const GET_TOKEN_ENDPOINT = '/v1/tokens'
export const GET_TOKEN_DETAIL_ENDPOINT = '/v1/tokens'

//optimex
export const GET_INDICATIVE_QUOTE_ENDPOINT = '/v1/solver/indicative-quote'

export const SEND_TRADE_INFO = '/v1/solver/trade-info'
export const GET_SLIPPAGE = '/v1/solver/slippage'

export const FAUCET_ENDPOINT = 'https://api-faucet.bitdex.xyz/faucet'

// invitation code
export const INVITATION_CODE_ENDPOINT = {
  BASE: '/access-codes',
  GENERATE_CODE: '/v1/access-codes/generate',
  LINK_WALLET_WITH_REFERRAL_CODE: '/v1/access-codes/referrals',
  GET_REFERRER_INFO: '/v1/access-codes/referred-by',
  GET_REFERRER_INFO_BY_REFERRAL_CODE: '/v1/access-codes/code',
}

// referral
export const REFERRAL_ENDPOINT = {
  BASE: '',
  ACCOUNT_REFERRAL_BALANCE: '/v1/referral/account',
  ACCOUNT_REFERRAL_STATISTICS: '/v1/referral/referrals',
  CREATE_CLAIM: '/v1/referral/claim',
  ACCOUNT_REFERRAL_CLAIM_HISTORY: '/v1/referral/claims',
}

export const FIXED_SWAP_VAULT_ENDPOINT = {
  BASE: '',
  VAULT_HOLDING: '',
  VAULT_DEPOSIT_HISTORY: '/v1/deposits',
  GET_VAULT_DEPOSIT_DETAIL: '/v1/deposits',
  REQUEST_DEPOSIT: '/v1/solver/request-info',
  SUBMIT_DEPOSIT: '/v1/solver/submit-deposit',
  GET_DEPOSIT_VAULT_INFO: '/v1/deposits',
}

export const WALLET_ENDPOINT = {
  LINK_WALLET: '/v1/analytics/wallet',
  TRACK_CONNECTED_WALLET: '/v1/wallet-connect',
}

// settings
export const SETTINGS_ENDPOINT = {
  BASE: '/v1/setting',
  TRADE: '/v1/setting/trade',
}

// across
export const ACROSS_ENDPOINT = {
  BASE: '',
  SUGGESTED_FEES: '/api/suggested-fees',
}

// across trade
export const ACROSS_TRADE_ENDPOINT = {
  BASE: '',
  OPTIMEX_AUTH: '/v1/trades/across/auth',
  ACROSS_REQUEST_REFUND: '/v1/trades/across/request-refund',
}
